"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flags = void 0;
exports.flags = {
    /* Afghanistan */ AF: '🇦🇫',
    /* Albania */ AL: '🇦🇱',
    /* Algeria */ DZ: '🇩🇿',
    /* Andorra */ AD: '🇦🇩',
    /* Angola */ AO: '🇦🇴',
    /* Antarctica */ AQ: '🇦🇶',
    /* Antigua & Barbuda */ AG: '🇦🇬',
    /* Argentina */ AR: '🇦🇷',
    /* Armenia */ AM: '🇦🇲',
    /* Aruba */ AW: '🇦🇼',
    /* Australia */ AU: '🇦🇺',
    /* Austria */ AT: '🇦🇹',
    /* Azerbaijan */ AZ: '🇦🇿',
    /* Bahamas */ BS: '🇧🇸',
    /* Bahrain */ BH: '🇧🇭',
    /* Bangladesh */ BD: '🇧🇩',
    /* Barbados */ BB: '🇧🇧',
    /* Belarus */ BY: '🇧🇾',
    /* Belgium */ BE: '🇧🇪',
    /* Belize */ BZ: '🇧🇿',
    /* Benin */ BJ: '🇧🇯',
    /* Bermuda */ BM: '🇧🇲',
    /* Bhutan */ BT: '🇧🇹',
    /* Bolivia */ BO: '🇧🇴',
    /* Bosnia & Herzegovina */ BA: '🇧🇦',
    /* Botswana */ BW: '🇧🇼',
    /* Brazil */ BR: '🇧🇷',
    /* British Virgin Islands */ VG: '🇻🇬',
    /* Brunei */ BN: '🇧🇳',
    /* Bulgaria */ BG: '🇧🇬',
    /* Burkina Faso */ BF: '🇧🇫',
    /* Burundi */ BI: '🇧🇮',
    /* Cambodia */ KH: '🇰🇭',
    /* Cameroon */ CM: '🇨🇲',
    /* Canada */ CA: '🇨🇦',
    /* Cape Verde */ CV: '🇨🇻',
    /* Caribbean Netherlands */ BQ: '🇧🇶',
    /* Cayman Islands */ KY: '🇰🇾',
    /* Chad */ TD: '🇹🇩',
    /* Chile */ CL: '🇨🇱',
    /* China */ CN: '🇨🇳',
    /* Colombia */ CO: '🇨🇴',
    /* Congo - Kinshasa */ CD: '🇨🇩',
    /* Costa Rica */ CR: '🇨🇷',
    /* Croatia */ HR: '🇭🇷',
    /* Cuba */ CU: '🇨🇺',
    /* Curaçao */ CW: '🇨🇼',
    /* Cyprus */ CY: '🇨🇾',
    /* Czech Republic */ CZ: '🇨🇿',
    /* Côte d’Ivoire */ CI: '🇨🇮',
    /* Denmark*/ DK: '🇩🇰',
    /* Dominican Republic */ DO: '🇩🇴',
    /* Ecuador */ EC: '🇪🇨',
    /* Egypt */ EG: '🇪🇬',
    /* El Salvador */ SV: '🇸🇻',
    /* Equatorial Guinea */ GQ: '🇬🇶',
    /* Estonia */ EE: '🇪🇪',
    /* Eswatini */ SZ: '🇸🇿',
    /* Ethiopia */ ET: '🇪🇹',
    /* Europe */ EU: '🇪🇺',
    /* Falkland Islands (Islas Malvinas) */ FK: '🇫🇰',
    /* Faroe Islands */ FO: '🇫🇴',
    /* Fiji */ FJ: '🇫🇯',
    /* Finland */ FI: '🇫🇮',
    /* France */ FR: '🇫🇷',
    /* French Polynesia */ PF: '🇵🇫',
    /* Gabon */ GA: '🇬🇦',
    /* Gambia */ GM: '🇬🇲',
    /* Georgia */ GE: '🇬🇪',
    /* Germany */ DE: '🇩🇪',
    /* Ghana */ GH: '🇬🇭',
    /* Gibraltar */ GI: '🇬🇮',
    /* Greece */ GR: '🇬🇷',
    /* Grenada */ GD: '🇬🇩',
    /* Guadeloupe */ GP: '🇬🇵',
    /* Guam */ GU: '🇬🇺',
    /* Guatemala */ GT: '🇬🇹',
    /* Guernsey */ GG: '🇬🇬',
    /* Guyana */ GY: '🇬🇾',
    /* Haiti */ HT: '🇭🇹',
    /* Honduras */ HN: '🇭🇳',
    /* Hong Kong */ HK: '🇭🇰',
    /* Hungary */ HU: '🇭🇺',
    /* Iceland */ IS: '🇮🇸',
    /* India */ IN: '🇮🇳',
    /* Indonesia */ ID: '🇮🇩',
    /* Iran */ IR: '🇮🇷',
    /* Iraq */ IQ: '🇮🇶',
    /* Ireland */ IE: '🇮🇪',
    /* Israel */ IL: '🇮🇱',
    /* Italy */ IT: '🇮🇹',
    /* Jamaica */ JM: '🇯🇲',
    /* Japan */ JP: '🇯🇵',
    /* Jersey */ JE: '🇯🇪',
    /* Jordan */ JO: '🇯🇴',
    /* Kazakhstan */ KZ: '🇰🇿',
    /* Kenya */ KE: '🇰🇪',
    /* Kosovo */ XK: '🇽🇰',
    /* Kuwait */ KW: '🇰🇼',
    /* Kyrgyzstan */ KG: '🇰🇬',
    /* Laos */ LA: '🇱🇦',
    /* Latvia */ LV: '🇱🇻',
    /* Lebanon */ LB: '🇱🇧',
    /* Lesotho */ LS: '🇱🇸',
    /* Libya */ LY: '🇱🇾',
    /* Liechtenstein */ LI: '🇱🇮',
    /* Lithuania */ LT: '🇱🇹',
    /* Luxembourg */ LU: '🇱🇺',
    /* Macao */ MO: '🇲🇴',
    /* Madagascar */ MG: '🇲🇬',
    /* Malawi */ MW: '🇲🇼',
    /* Malaysia */ MY: '🇲🇾',
    /* Maldives */ MV: '🇲🇻',
    /* Mali */ ML: '🇲🇱',
    /* Malta */ MT: '🇲🇹',
    /* Martinique */ MQ: '🇲🇶',
    /* Mauritania */ MR: '🇲🇷',
    /* Mauritius */ MU: '🇲🇺',
    /* Mayotte */ YT: '🇾🇹',
    /* Mexico */ MX: '🇲🇽',
    /* Micronesia */ FM: '🇫🇲',
    /* Moldova */ MD: '🇲🇩',
    /* Monaco */ MC: '🇲🇨',
    /* Mongolia */ MN: '🇲🇳',
    /* Montenegro */ ME: '🇲🇪',
    /* Morocco */ MA: '🇲🇦',
    /* Mozambique */ MZ: '🇲🇿',
    /* Myanmar (Burma) */ MM: '🇲🇲',
    /* Namibia */ NA: '🇳🇦',
    /* Nepal */ NP: '🇳🇵',
    /* Netherlands */ NL: '🇳🇱',
    /* New Caledonia */ NC: '🇳🇨',
    /* New Zealand */ NZ: '🇳🇿',
    /* Nicaragua */ NI: '🇳🇮',
    /* Niger */ NE: '🇳🇪',
    /* Nigeria */ NG: '🇳🇬',
    /* Norfolk Island */ NF: '🇳🇫',
    /* North Macedonia */ MK: '🇲🇰',
    /* Norway */ NO: '🇳🇴',
    /* Oman */ OM: '🇴🇲',
    /* Pakistan */ PK: '🇵🇰',
    /* Palestine */ PS: '🇵🇸',
    /* Panama */ PA: '🇵🇦',
    /* Papua New Guinea */ PG: '🇵🇬',
    /* Paraguay */ PY: '🇵🇾',
    /* Peru */ PE: '🇵🇪',
    /* Philippines */ PH: '🇵🇭',
    /* Poland */ PL: '🇵🇱',
    /* Portugal */ PT: '🇵🇹',
    /* Puerto Rico */ PR: '🇵🇷',
    /* Qatar */ QA: '🇶🇦',
    /* Romania */ RO: '🇷🇴',
    /* Russia */ RU: '🇷🇺',
    /* Rwanda */ RW: '🇷🇼',
    /* Réunion */ RE: '🇷🇪',
    /* San Marino */ SM: '🇸🇲',
    /* Saudi Arabia */ SA: '🇸🇦',
    /* Senegal */ SN: '🇸🇳',
    /* Serbia */ RS: '🇷🇸',
    /* Seychelles */ SC: '🇸🇨',
    /* Sierra Leone */ SL: '🇸🇱',
    /* Singapore */ SG: '🇸🇬',
    /* Slovakia */ SK: '🇸🇰',
    /* Slovenia */ SI: '🇸🇮',
    /* Somalia */ SO: '🇸🇴',
    /* South Africa */ ZA: '🇿🇦',
    /* South Korea */ KR: '🇰🇷',
    /* South Sudan */ SS: '🇸🇸',
    /* Spain */ ES: '🇪🇸',
    /* Sri Lanka */ LK: '🇱🇰',
    /* St. Kitts & Nevis */ KN: '🇰🇳',
    /* St. Lucia */ LC: '🇱🇨',
    /* St. Vincent & Grenadines */ VC: '🇻🇨',
    /* Sudan */ SD: '🇸🇩',
    /* Suriname */ SR: '🇸🇷',
    /* Sweden */ SE: '🇸🇪',
    /* Switzerland */ CH: '🇨🇭',
    /* Syria */ SY: '🇸🇾',
    /* Taiwan */ TW: '🇹🇼',
    /* Tajikistan */ TJ: '🇹🇯',
    /* Tanzania */ TZ: '🇹🇿',
    /* Thailand */ TH: '🇹🇭',
    /* Timor-Leste */ TL: '🇹🇱',
    /* Togo */ TG: '🇹🇬',
    /* Trinidad & Tobago */ TT: '🇹🇹',
    /* Tunisia */ TN: '🇹🇳',
    /* Turkey */ TR: '🇹🇷',
    /* Turkmenistan */ TM: '🇹🇲',
    /* Tuvalu */ TV: '🇹🇻',
    /* U.S. Virgin Islands */ VI: '🇻🇮',
    /* Uganda */ UG: '🇺🇬',
    /* Ukraine */ UA: '🇺🇦',
    /* United Arab Emirates */ AE: '🇦🇪',
    /* United Kingdom */ GB: '🇬🇧',
    /* United States */ US: '🇺🇸',
    /* Uruguay */ UY: '🇺🇾',
    /* Uzbekistan */ UZ: '🇺🇿',
    /* Vanuatu */ VU: '🇻🇺',
    /* Venezuela */ VE: '🇻🇪',
    /* Vietnam */ VN: '🇻🇳',
    /* Western Sahara */ EH: '🇪🇭',
    /* Yemen */ YE: '🇾🇪',
    /* Zambia */ ZM: '🇿🇲',
    /* Zimbabwe */ ZW: '🇿🇼',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmxhZ3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbG9jYWxlL2ZsYWdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsS0FBSyxHQUVkO0lBQ0YsaUJBQWlCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDNUIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsWUFBWSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3ZCLGdCQUFnQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzNCLHVCQUF1QixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ2xDLGVBQWUsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMxQixhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsV0FBVyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3RCLGVBQWUsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMxQixhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsZ0JBQWdCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDM0IsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixnQkFBZ0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMzQixjQUFjLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDekIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsV0FBVyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3RCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLDBCQUEwQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3JDLGNBQWMsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN6QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsNEJBQTRCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkMsWUFBWSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3ZCLGNBQWMsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN6QixrQkFBa0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUM3QixhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsY0FBYyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3pCLGNBQWMsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN6QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsZ0JBQWdCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDM0IsMkJBQTJCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdEMsb0JBQW9CLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDL0IsVUFBVSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3JCLFdBQVcsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN0QixXQUFXLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdEIsY0FBYyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3pCLHNCQUFzQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ2pDLGdCQUFnQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzNCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixVQUFVLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDckIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLFlBQVksQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN2QixvQkFBb0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMvQixtQkFBbUIsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUM5QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsd0JBQXdCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDbkMsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLFdBQVcsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN0QixpQkFBaUIsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUM1Qix1QkFBdUIsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUNsQyxhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsY0FBYyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3pCLGNBQWMsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN6QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsdUNBQXVDLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDbEQsbUJBQW1CLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDOUIsVUFBVSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3JCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsc0JBQXNCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDakMsV0FBVyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3RCLFlBQVksQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN2QixhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLFdBQVcsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN0QixlQUFlLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDMUIsWUFBWSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3ZCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixnQkFBZ0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMzQixVQUFVLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDckIsZUFBZSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzFCLGNBQWMsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN6QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsV0FBVyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3RCLGNBQWMsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN6QixlQUFlLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDMUIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixXQUFXLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdEIsZUFBZSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzFCLFVBQVUsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUNyQixVQUFVLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDckIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLFlBQVksQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN2QixXQUFXLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdEIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLFdBQVcsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN0QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsWUFBWSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3ZCLGdCQUFnQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzNCLFdBQVcsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN0QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsWUFBWSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3ZCLGdCQUFnQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzNCLFVBQVUsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUNyQixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixXQUFXLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdEIsbUJBQW1CLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDOUIsZUFBZSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzFCLGdCQUFnQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzNCLFdBQVcsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN0QixnQkFBZ0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMzQixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsY0FBYyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3pCLGNBQWMsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN6QixVQUFVLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDckIsV0FBVyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3RCLGdCQUFnQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzNCLGdCQUFnQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzNCLGVBQWUsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMxQixhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsWUFBWSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3ZCLGdCQUFnQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzNCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsY0FBYyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3pCLGdCQUFnQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzNCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixnQkFBZ0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMzQixxQkFBcUIsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUNoQyxhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsV0FBVyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3RCLGlCQUFpQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzVCLG1CQUFtQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzlCLGlCQUFpQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzVCLGVBQWUsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMxQixXQUFXLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdEIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLG9CQUFvQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQy9CLHFCQUFxQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ2hDLFlBQVksQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN2QixVQUFVLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDckIsY0FBYyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3pCLGVBQWUsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMxQixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsc0JBQXNCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDakMsY0FBYyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3pCLFVBQVUsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUNyQixpQkFBaUIsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUM1QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsY0FBYyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3pCLGlCQUFpQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzVCLFdBQVcsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN0QixhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsWUFBWSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3ZCLFlBQVksQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN2QixhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsZ0JBQWdCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDM0Isa0JBQWtCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDN0IsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLFlBQVksQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN2QixnQkFBZ0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMzQixrQkFBa0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUM3QixlQUFlLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDMUIsY0FBYyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3pCLGNBQWMsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN6QixhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsa0JBQWtCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDN0IsaUJBQWlCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDNUIsaUJBQWlCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDNUIsV0FBVyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3RCLGVBQWUsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMxQix1QkFBdUIsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUNsQyxlQUFlLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDMUIsOEJBQThCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDekMsV0FBVyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3RCLGNBQWMsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN6QixZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsaUJBQWlCLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDNUIsV0FBVyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3RCLFlBQVksQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN2QixnQkFBZ0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMzQixjQUFjLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDekIsY0FBYyxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3pCLGlCQUFpQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzVCLFVBQVUsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUNyQix1QkFBdUIsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUNsQyxhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsWUFBWSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3ZCLGtCQUFrQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzdCLFlBQVksQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN2Qix5QkFBeUIsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUNwQyxZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdkIsYUFBYSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3hCLDBCQUEwQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3JDLG9CQUFvQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQy9CLG1CQUFtQixDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzlCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixnQkFBZ0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMzQixhQUFhLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDeEIsZUFBZSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQzFCLGFBQWEsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUN4QixvQkFBb0IsQ0FBQyxFQUFFLEVBQUUsTUFBTTtJQUMvQixXQUFXLENBQUMsRUFBRSxFQUFFLE1BQU07SUFDdEIsWUFBWSxDQUFDLEVBQUUsRUFBRSxNQUFNO0lBQ3ZCLGNBQWMsQ0FBQyxFQUFFLEVBQUUsTUFBTTtDQUNqQixDQUFDIn0=